import React from 'react'
import * as Yup from 'yup'

import { Field } from 'widgets/Field'
import { Form } from 'widgets/Form'

type MyFormValues = {
  email: string
  password: string
}

interface SignupFormProps {
  onSubmit: (e: any) => void
  initialValues?: MyFormValues
  loading?: boolean
  errors?: string[] | string
  isReferral?: boolean
}

const validationSchema = Yup.object().shape({
  email: Yup.string().email().required('Required'),
  password: Yup.string().min(6, 'Too Short!').required('Required'),
})

export const SignupForm = ({
  onSubmit = () => null,
  initialValues = {
    email: '',
    password: '',
  },
  errors = [],
  loading = false,
  isReferral = false,
}: SignupFormProps) => {
  return (
    <Form
      errors={errors}
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={onSubmit}
      loading={loading}
      submitCopy={isReferral ? 'LETS GROW!' : 'SIGN UP'}
    >
      {() => (
        <>
          <Field name='email' placeholder='Email' />
          <Field name='password' type='password' placeholder='Password' />
        </>
      )}
    </Form>
  )
}
